import React from "react";

/** Primary emblem — uses the client-supplied PNG (script "MeLaVi" inside the oval
 *  ring with the crimson butterfly). This is the anchor of the brand and now
 *  lives in the site header.
 */
export const LogoEmblem = ({ size = 120, className = "" }) => (
  <img
    src="/logo.png"
    alt="MELAVI"
    width={size}
    style={{ height: "auto", objectFit: "contain" }}
    className={`inline-block ${className}`}
    data-testid="logo-emblem"
  />
);

/** Butterfly-only mark — derived from the logo, used as favicon, cursor
 *  companion, loader hero, and micro-mark.
 */
export const Butterfly = ({ size = 20, color = "#AE2B31", className = "" }) => (
  <svg
    width={size}
    height={size * 0.85}
    viewBox="0 0 40 34"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Two upper wings + two lower wings, hand-drawn feel */}
    <path d="M20 16 C 15 8, 6 4, 3 8 C 1 12, 4 17, 20 18 Z" />
    <path d="M20 16 C 25 8, 34 4, 37 8 C 39 12, 36 17, 20 18 Z" />
    <path d="M20 18 C 15 22, 8 24, 6 28 C 6 32, 14 30, 20 24 Z" />
    <path d="M20 18 C 25 22, 32 24, 34 28 C 34 32, 26 30, 20 24 Z" />
    <line x1="20" y1="10" x2="20" y2="26" stroke={color} strokeWidth="1.2" />
  </svg>
);

/** Horizontal header lockup — "MELAVI" letter-spaced, butterfly above the A */
export const HeaderLockup = ({ className = "", onClick }) => (
  <a
    href="/"
    onClick={onClick}
    className={`inline-flex items-end gap-0 relative ${className}`}
    data-testid="logo-header-lockup"
    aria-label="MELAVI — home"
  >
    <span className="serif text-[26px] md:text-[30px] tracking-[0.28em] leading-none text-ink">
      MEL
    </span>
    <span className="relative inline-block">
      <span className="serif text-[26px] md:text-[30px] tracking-[0.28em] leading-none text-ink">A</span>
      <span className="absolute left-1/2 -translate-x-1/2 -top-[16px]">
        <Butterfly size={16} />
      </span>
    </span>
    <span className="serif text-[26px] md:text-[30px] tracking-[0.28em] leading-none text-ink">VI</span>
  </a>
);
